<div class="{{ dwInDatePicker ? prefixCls + '-panel' : '' }}">
  <div
    class="{{ prefixCls }}-inner {{ dwInDatePicker ? prefixCls + '-column-' + enabledColumns : '' }}"
    [style.width.px]="dwInDatePicker ? null : enabledColumns * 56">
    <div class="{{ prefixCls }}-input-wrap">
      <input
        type="text"
        class="{{ prefixCls }}-input"
        [placeholder]="dwPlaceHolder"
        [dwTime]="format"
        [(ngModel)]="time.value"
        (blur)="time.changed()">
      <a
        *ngIf="dwAllowEmpty"
        class="{{ prefixCls }}-clear-btn"
        [attr.title]="dwClearText"
        (click)="clear()">
      </a>
    </div>
    <div class="{{ prefixCls }}-combobox">
      <div
        *ngIf="hourEnabled"
        #hourListElement
        class="{{ prefixCls }}-select">
        <ul>
          <ng-container *ngFor="let hour of hourRange">
            <li
              *ngIf="!(dwHideDisabledOptions && hour.disabled)"
              (click)="selectHour(hour)"
              class="
                {{ isSelectedHour(hour) ? prefixCls + '-select-option-selected' : '' }}
                {{ hour.disabled ? prefixCls + '-select-option-disabled' : '' }}
              "
            >
              {{ hour.index | number:'2.0-0' }}
            </li>
          </ng-container>
        </ul>
      </div>
      <div
        *ngIf="minuteEnabled"
        #minuteListElement
        class="{{ prefixCls }}-select">
        <ul>
          <ng-container *ngFor="let minute of minuteRange">
            <li
              *ngIf="!(dwHideDisabledOptions && minute.disabled)"
              (click)="selectMinute(minute)"
              class="
                {{ isSelectedMinute(minute) ? prefixCls + '-select-option-selected' : '' }}
                {{ minute.disabled ? prefixCls + '-select-option-disabled' : '' }}
              "
            >
              {{ minute.index | number:'2.0-0' }}
            </li>
          </ng-container>
        </ul>
      </div>
      <div
        *ngIf="secondEnabled"
        #secondListElement
        class="{{ prefixCls }}-select">
        <ul>
          <ng-container *ngFor="let second of secondRange">
            <li
              *ngIf="!(dwHideDisabledOptions && second.disabled)"
              (click)="selectSecond(second)"
              class="
                {{ isSelectedSecond(second) ? prefixCls + '-select-option-selected' : '' }}
                {{ second.disabled ? prefixCls + '-select-option-disabled' : '' }}
              "
            >
              {{ second.index | number:'2.0-0' }}
            </li>
          </ng-container>
        </ul>
      </div>
    </div>
    <div class="{{ prefixCls }}-addon" *ngIf="dwAddOn">
      <ng-template [ngTemplateOutlet]="dwAddOn"></ng-template>
    </div>
  </div>
</div>